interface DebounceType {
  timeout: number | undefined;
}
interface DebounceQueueType {
  [key: string]: DebounceType;
}

const DEBOUNCE_QUEUE: DebounceQueueType = {};

const debounce = (key: string, func: any, wait: number) => {
  if (DEBOUNCE_QUEUE[key] && DEBOUNCE_QUEUE[key].timeout) {
    clearTimeout(DEBOUNCE_QUEUE[key].timeout);
    DEBOUNCE_QUEUE[key].timeout = undefined;
  }

  let ret: any = null;
  const timeout = setTimeout(() => {
    ret = func();
    delete DEBOUNCE_QUEUE[key];
  }, wait);

  if (DEBOUNCE_QUEUE[key]) {
    DEBOUNCE_QUEUE[key].timeout = timeout;
  } else {
    DEBOUNCE_QUEUE[key] = {
      timeout: timeout
    } as DebounceType;
  }
  return ret;
};

export default debounce;
